import React, { useEffect, useRef, useState } from "react"
import MessagesIconWhite from '../../../../../assests/header/icons/Messages-icon-white.png'
import MessagesIconDark from '../../../../../assests/header/icons/Messages-icon-dark.png'
import useClickOutside from "../../../../../hooks/useClickOutside"
import IconHeaderBackground from "../IconHeaderBackground"
import classes from '../Icons.module.css'
import Messages from "../../HeaderDashboard/Messages"
import { useDispatch, useSelector } from "react-redux"
import { messagesApi } from "../../../../../utils"
import { messagesActions } from "../../../../../store/messages-slice"
import { throwApiError } from '../../../../lms-shared/store/error-handling-actions'
import { onKeyDown } from "../../../../../service"
import { initMessages } from "../../../../../store/messages-actions"


const MessagesBtn = () => {

    const [showMessages, setShowMessages] = useState(false)
    const messages = useSelector(state => state.messages.messages);
    const unReadMessages = useSelector(state => state.messages.unReadMessages);
    const { applicationId } = useSelector(state => state.application);
    const uiData = useSelector((state) => state.general.uiData);
    const texts = useSelector(state => state.translate.texts);
    const popupRef = useRef(null);
    const dispatch = useDispatch()

    useEffect(() => {
        if (!messages && applicationId && uiData)
            dispatch(initMessages(null, uiData))
    }, [dispatch, messages, applicationId])

    function openOrClose() {
        setShowMessages((prevShowMessages) => {
            if (prevShowMessages) {
                setToRead()
            }
            return !prevShowMessages
        })
    }

    useClickOutside(popupRef, () => {
        {
            setShowMessages((prevShowMessages) => {
                if (prevShowMessages) {
                    setToRead()
                    return false
                }
            })
        }
    }, messages);

    function setToRead() {
        if (messages) {
            let newMessages = [...messages]
            if (newMessages.length > 0) {
                let messagesIds = []
                newMessages.map(m => {
                    if (!m.isRead) {
                        messagesIds.push(m.id)
                    }
                });
                if (messagesIds.length > 0) {
                    const data = {
                        messagesIds: messagesIds
                    }
                    messagesApi.messagesSetReadRangePost({ messageSetReadRangeInput: data }, (error, resdata, response) => {
                        if (error) {
                            dispatch(throwApiError({ userMessage: texts.MessageContentMessagesSetReadRange, error: error, statusCode: response?.statusCode, message: "messagesSetReadRangePost " + error.message, level: 1, component: "MessagesBtn", line: 67 }))
                        } else {
                            dispatch(messagesActions.setUnReadMessages(0))
                        }
                    })
                }
            }
        }
    }

    return (
        <>
            <div ref={popupRef} className={` ${!showMessages ? classes.Icon : classes.OpenIconImg}`}>
                <div className={classes.UnReadMessagesContainer}>
                    {unReadMessages > 0 ? <div className={classes.UnReadMessages}>{unReadMessages}</div> : <></>}
                    <img src={` ${showMessages ? MessagesIconDark : MessagesIconWhite}`} alt="MessagesIcon" className={classes.IconImg} onClick={(e) => openOrClose(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => openOrClose(e))} />
                </div>

                {showMessages && <IconHeaderBackground title={texts.message} close={openOrClose}><Messages /></IconHeaderBackground>}
            </div>
        </>
    )
}

export default MessagesBtn